'use client'

import { SessionProvider } from "next-auth/react"
import { ThemeProvider } from "next-themes" 
import { NextIntlClientProvider } from "next-intl"
import { useParams } from "next/navigation"
import { useEffect, useState } from "react"

export function ClientProvider({ children }: { children: React.ReactNode }) {
  // Get the current locale from the URL params
  const params = useParams();
  const locale = params?.locale || 'en';
  
  // Server state - avoid hydration issues
  const [mounted, setMounted] = useState(false);
  const [messages, setMessages] = useState({});

  // Wait until after client-side hydration to load messages
  useEffect(() => {
    setMounted(true);
    
    // Safely access window
    if (typeof window !== 'undefined') {
      const messagesObject = (window as any).__NEXT_INTL_MESSAGES__;
      if (messagesObject) {
        setMessages(messagesObject);
      }
    }
  }, []);

  // Return consistent markup across server/client to avoid hydration errors
  return (
    <SessionProvider refetchInterval={0} refetchOnWindowFocus={false}>
      <NextIntlClientProvider 
        locale={String(locale)} 
        messages={messages}
        // Skip rendering until client-side to avoid hydration errors
        skipInitialDataFetch={true}
      >
        <ThemeProvider 
          attribute="class" 
          defaultTheme="light"
          enableSystem={mounted}
          disableTransitionOnChange
        >
          <div className={mounted ? "min-h-screen bg-background font-sans antialiased" : ""}>
            {children}
          </div>
        </ThemeProvider>
      </NextIntlClientProvider>
    </SessionProvider>
  )
}